// BESC Address
const BESC_ADDRESS = '0x83048f0Bf34FEeD8CEd419455a4320A735a92e9d'

export { BESC_ADDRESS }
